import React, { useState } from "react";
import axios from "axios";
import { baseURL } from "../../http";

const EmailForm = () => {
  const [recipient, setSenderAddress] = useState("");
  const [content, setContent] = useState("");
  const [subject, Setsubject] = useState("Test Subject");

  const handleSubmit = async (e) => {
    e.preventDefault();

    try {
      const response = await axios.post(baseURL + "/sendmail", {
        recipient,
        content,
        subject,
      });
      console.log("Email sent successfully:", response.data);
    } catch (error) {
      console.error("Error sending email:", error);
    }
  };

  return (
    <div>
      <h2>Send Email</h2>
      <form onSubmit={handleSubmit}>
        <input
          type="email"
          placeholder="Sender Address"
          value={recipient}
          onChange={(e) => setSenderAddress(e.target.value)}
          required
        />
        <br/>
        <br/>
        <textarea
          placeholder="Email Content"
          value={content}
          onChange={(e) => setContent(e.target.value)}
          required
        ></textarea>
        <br/>
        <br/>

        <button type="submit">Send Email</button>
      </form>
    </div>
  );
};

export default EmailForm;
